/**
 * @file Renders a boolean value as a Yes/No label, or a custom pair of labels.
 */
const LABEL_NO = "No";
const LABEL_YES = "Yes";

/**
 * Renders a boolean value as the Yes/No label, or a custom pair of labels when given.
 */
const renderBoolean = <T = string>(
  value: boolean | undefined,
  trueValue: T | string = LABEL_YES,
  falseValue: T | string = LABEL_NO,
): T | string | undefined => {
  const valuesMap: Record<string, T | string> = {
    true: trueValue,
    false: falseValue,
  };

  const result = valuesMap[String(value)];

  return result;
};

export default renderBoolean;
